module.exports = __webpack_public_path__ + "img/yolearn_logo.8cf4fc8c.png";